module.exports = __webpack_public_path__ + "static/media/74.54746c1e.png";